import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * 로컬 스냅샷 기반 앱에서는 경로 변경마다 startLoading()을 켜면,
 * Calendar 등 stopLoading을 호출하지 않는 페이지에서 전역 오버레이가
 * 수 초~폴백(15초)까지 고착되는 문제가 생긴다.
 * 전역 로딩은 각 작업(생성/삭제 등)에서만 사용하고, 여기서는 스크롤만 맞춘다.
 */
function RouteChangeHandler() {
  const location = useLocation()
  const prevPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    const pathname = location.pathname
    const changed = prevPathnameRef.current !== null && prevPathnameRef.current !== pathname
    prevPathnameRef.current = pathname
    if (changed) {
      window.scrollTo(0, 0)
    }
  }, [location.pathname])

  return null
}

export default RouteChangeHandler
